import "./ellips.scss";
import React, { useRef, useEffect } from "react";

interface Props {
  content: string;
  endStr: string;
  style?: React.CSSProperties;
}

const LineEllipsisSpan = ({ content, endStr, style = {} }: Props) => {
  
  const spanRef = useRef<any>(null);

  useEffect(() => {
    const span = spanRef.current;
    if (span) {
      const isOverflow = span.scrollHeight > span.clientHeight;
      if (isOverflow) {
        let currentText = content;
        while (span.scrollHeight > span.clientHeight) {
          currentText = currentText.slice(0, -1);
          span.textContent = currentText + `...${endStr}`;
        }
      }
    }
  }, [endStr]);

  return (
    <span ref={spanRef} className="ellips" style={style}>
      {content + endStr}
    </span>
  );
};

export default LineEllipsisSpan;
